var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, debounce, IconButton, MenuItem, Select, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, Edit02Icon } from 'hugeicons-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useGetAllCompaniesQuery, useGetPaginatedCompaniesQuery } from '../../../application/features/companies/company-api';
import { useLazyGetLocationQuery, useLazySearchCityLocationQuery } from '../../../application/features/pdok/pdok-api';
import useTranslate from '../../../localization/helpers';
import FilterButton from '../../components/FilterButton';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import { Permissions } from '../../permissions';
import AddCompany from './add-company';
import CompaniesDatagrid from './companies-datagrid';
import CompanyCards from './company-cards';
import ActivateCompanyDialog from './company-status/ActivateCompany';
import DeActivateCompanyDialog from './company-status/DeActivateCompany';
import UpdateCompany from './update-company';
var Companies = function () {
    var _a;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var _c = __read(useState(false), 2), addCompanyModalOpen = _c[0], setAddCompanyModalOpen = _c[1];
    var _d = __read(useState(false), 2), openFilterDrawer = _d[0], setOpenFilterDrawer = _d[1];
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var _e = __read(useState({ isOpen: false }), 2), updateCompany = _e[0], setUpdateCompany = _e[1];
    var _f = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        locations: [],
        companies: [],
        filterField: undefined,
        filterValue: undefined,
        filterOperator: undefined
    }), 2), companyFilters = _f[0], setCompanyFilters = _f[1];
    var _g = __read(useState(''), 2), locationSearchTerm = _g[0], setLocationSearchTerm = _g[1];
    var _h = __read(useState({ isOpen: false, isActive: false }), 2), companyStatusModal = _h[0], setCompanyStatusModal = _h[1];
    var _j = __read(useLazyGetLocationQuery(), 1), triggerGetLocation = _j[0];
    var _k = __read(useLazySearchCityLocationQuery(), 2), triggerSearchLocation = _k[0], _l = _k[1], _m = _l.data, locations = _m === void 0 ? [] : _m, isLocationsFetching = _l.isFetching;
    var _o = useGetAllCompaniesQuery({
        filterByCompany: true
    }), _p = _o.data, allCompanies = _p === void 0 ? [] : _p, allCompaniesLoading = _o.isLoading;
    var _q = useGetPaginatedCompaniesQuery(companyFilters, {
        refetchOnMountOrArgChange: true
    }), data = _q.data, companiesLoading = _q.isFetching;
    var _r = (data !== null && data !== void 0 ? data : {}).items, companies = _r === void 0 ? [] : _r;
    var activationModalOpen = companyStatusModal.isOpen && companyStatusModal.isActive;
    var deActivationModalOpen = companyStatusModal.isOpen && !companyStatusModal.isActive;
    var _s = useForm({
        defaultValues: {
            page: AppConsts.DEFAULT_PAGE_NUMBER,
            pageSize: AppConsts.DEFAULT_PAGE_SIZE,
            companies: [],
            locations: []
        }
    }), control = _s.control, handleSubmit = _s.handleSubmit, setValue = _s.setValue, reset = _s.reset;
    var BooleanFilterInput = function (_a) {
        var _b;
        var item = _a.item, applyValue = _a.applyValue;
        return (_jsxs(Select, { value: (_b = item.value) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return applyValue(__assign(__assign({}, item), { value: e.target.value === 'true' })); }, fullWidth: true, children: [_jsx(MenuItem, { value: 'true', children: translate('common.true') }), _jsx(MenuItem, { value: 'false', children: translate('common.false') })] }));
    };
    var booleanFilterOperators = [
        {
            label: 'is',
            value: 'is',
            getApplyFilterFn: function (filterItem) {
                return filterItem.value === true || filterItem.value === false
                    ? function (params) { return params.value === filterItem.value; }
                    : null;
            },
            InputComponent: BooleanFilterInput
        }
    ];
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setCompanyFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setCompanyFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setCompanyFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _t = __read(useState({
        items: []
    }), 2), filterModel = _t[0], setFilterModel = _t[1];
    var rowCountRef = useRef((_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data]);
    var handleUpdateCompany = function (companyId) {
        setUpdateCompany({ id: companyId.toString(), isOpen: true });
    };
    var openCompanyStatusModal = function (company, isActive) {
        setCompanyStatusModal({
            company: company,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeCompanyStatusModal = function () {
        setCompanyStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var companiesColumn = [
        {
            field: 'name',
            headerName: translate('common.name'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'locationName',
            headerName: translate('common.location'),
            valueGetter: function (_, row) {
                return "".concat(row.locationCode ? "".concat(row.locationCode, " ") : '', " ").concat(row.locationName);
            },
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'emailAddress',
            headerName: translate('common.email'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'phoneNumber',
            headerName: translate('common.phone'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'isActive',
            headerName: translate('common.active'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: false,
            // type: 'boolean',
            // filterOperators: booleanFilterOperators,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Companies.Update], children: _jsx(Switch, { checked: params.value, onClick: function (e) {
                        e.stopPropagation();
                        openCompanyStatusModal(params.row, !params.value);
                    } }) })); }
        },
        {
            field: 'actions',
            headerName: translate('actions.edit'),
            align: 'center',
            headerAlign: 'center',
            minWidth: isXs ? 140 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 140 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: function (params) {
                return (_jsx(ProtectedElement, { permissions: [Permissions.Users.Update], children: _jsx(IconButton, { size: 'medium', onClick: function () { return handleUpdateCompany(params.id); }, children: _jsx(Edit02Icon, {}) }) }));
            }
        }
    ];
    var handleOpenAddCompany = function () {
        setAddCompanyModalOpen(true);
    };
    var handlePaginationModelChange = function (model) {
        setCompanyFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var getSearchResults = useMemo(function () {
        return debounce(function (searchTerm) {
            if (searchTerm)
                triggerSearchLocation(searchTerm);
        }, 1000);
    }, [triggerSearchLocation]);
    useEffect(function () {
        getSearchResults(locationSearchTerm);
    }, [getSearchResults, locationSearchTerm]);
    var onLocationChange = function (locations) { return __awaiter(void 0, void 0, void 0, function () {
        var searchedLocations, locationPromises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchedLocations = [];
                    locationPromises = locations.map(function (location) { return __awaiter(void 0, void 0, void 0, function () {
                        var details;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, triggerGetLocation(location.id).unwrap()];
                                case 1:
                                    details = _a.sent();
                                    if (details) {
                                        searchedLocations.push(details.woonplaatsnaam);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(locationPromises)];
                case 1:
                    _a.sent();
                    setValue('locations', searchedLocations);
                    return [2 /*return*/];
            }
        });
    }); };
    var onFilterCompanies = function (query) {
        setCompanyFilters(__assign(__assign({}, companyFilters), { page: AppConsts.DEFAULT_PAGE_NUMBER, pageSize: AppConsts.DEFAULT_PAGE_SIZE, companies: query.companies, locations: query.locations }));
    };
    var handleSortModelChange = function (model) {
        setCompanyFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { display: 'flex', gap: 1, alignItems: 'center', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', mb: { xs: 0, md: 0, lg: 2 }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.companies') }), _jsx(ProtectedElement, { permissions: [Permissions.Companies.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleOpenAddCompany, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.company') }) })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick })), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(CompanyCards, { onFilterCompanies: onFilterCompanies, onLocationChange: onLocationChange, control: control, handleSubmit: handleSubmit, reset: reset, companyFilters: companyFilters, setCompanyFilters: setCompanyFilters, setValue: setValue, companyC: companies, totalCount: (data === null || data === void 0 ? void 0 : data.totalCount) || 0, page: companyFilters.page, pageSize: companyFilters.pageSize, onPageChange: function (newPage) {
                    return setCompanyFilters(function (prev) { return (__assign(__assign({}, prev), { page: newPage })); });
                }, onEdit: handleUpdateCompany, onStatusChange: openCompanyStatusModal, loading: companiesLoading })) : (_jsx(CompaniesDatagrid, { control: control, handleSubmit: handleSubmit, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, setLocationSearchTerm: setLocationSearchTerm, allCompanies: allCompanies, allCompaniesLoading: allCompaniesLoading, companies: companies, companiesColumn: companiesColumn, companiesLoading: companiesLoading, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, data: data, handlePaginationModelChange: handlePaginationModelChange, handleSortModelChange: handleSortModelChange, isLocationsFetching: isLocationsFetching, isXs: isXs, iscreen9001200: iscreen9001200, isscreen600900: isscreen600900, isscreen600900Landscape: isscreen600900Landscape, locations: locations, onFilterCompanies: onFilterCompanies, onLocationChange: onLocationChange, rowCount: rowCount, paginationModel: {
                    page: companyFilters.page - 1,
                    pageSize: companyFilters.pageSize
                } })), _jsx(AddCompany, { onClose: function () { return setAddCompanyModalOpen(false); }, open: addCompanyModalOpen }), updateCompany.isOpen && (_jsx(UpdateCompany, { companyId: updateCompany.id, open: updateCompany.isOpen, onClose: function () { return setUpdateCompany({ isOpen: false }); } })), activationModalOpen && (_jsx(ActivateCompanyDialog, { company: companyStatusModal.company, isOpen: activationModalOpen, onClose: closeCompanyStatusModal })), deActivationModalOpen && (_jsx(DeActivateCompanyDialog, { company: companyStatusModal.company, isOpen: deActivationModalOpen, onClose: closeCompanyStatusModal }))] }));
};
export default Companies;
